import { render, staticRenderFns } from "./SpringBoardLogs.vue?vue&type=template&id=680584ea&"
import script from "./SpringBoardLogs.vue?vue&type=script&lang=js&"
export * from "./SpringBoardLogs.vue?vue&type=script&lang=js&"
import style0 from "./SpringBoardLogs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports